import { Lock } from "lucide-react";
import { badgeIconUrl, BADGE_CATEGORIES, COACH_BADGE_CATEGORIES } from "@/lib/badges";
import { cn } from "@/lib/utils";

const RING = {
  orange: "from-orange-400 to-orange-600 ring-orange-200",
  blue: "from-blue-400 to-blue-600 ring-blue-200",
  green: "from-green-400 to-green-600 ring-green-200",
  purple: "from-purple-400 to-purple-600 ring-purple-200",
  amber: "from-amber-400 to-amber-600 ring-amber-200",
  yellow: "from-yellow-300 to-yellow-600 ring-yellow-200",
};

export default function AchievementBadge({
  title,
  description,
  icon = "first-checkin",
  category = "regularity",
  earned = true,
  isNew = false,
  size = "md",
  showLabel = true,
  progress,
  categories = BADGE_CATEGORIES,
}) {
  const cat = categories[category] || categories.regularity || BADGE_CATEGORIES.regularity;
  const ring = RING[cat.color] || RING.orange;
  const dim = size === "sm" ? "w-12 h-12" : size === "lg" ? "w-20 h-20" : "w-16 h-16";

  return (
    <div className={cn("flex flex-col items-center text-center gap-2", !earned && "opacity-80")} data-testid={`badge-${icon}`}>
      <div className="relative">
        <div
          className={cn(
            dim,
            "rounded-full flex items-center justify-center ring-4 shadow-sm transition-transform",
            earned ? `bg-gradient-to-br ${ring}` : "bg-slate-100 ring-slate-200 grayscale",
          )}
        >
          {earned ? (
            <img src={badgeIconUrl(icon)} alt="" className={cn(size === "sm" ? "w-8 h-8" : size === "lg" ? "w-14 h-14" : "w-11 h-11")} />
          ) : (
            <Lock className="w-5 h-5 text-slate-400" />
          )}
        </div>
        {isNew && earned && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">NEW</span>
        )}
      </div>
      {showLabel && (
        <div className="min-w-0 max-w-[110px]">
          <p className={cn("text-xs font-semibold leading-tight", earned ? "text-slate-900" : "text-slate-500")}>{title}</p>
          {description && size !== "sm" && (
            <p className="text-[10px] text-slate-400 mt-0.5 line-clamp-2">{description}</p>
          )}
          {!earned && progress?.target > 0 && (
            <div className="mt-2">
              <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div className="h-full bg-blue-500 rounded-full" style={{ width: `${progress.percent || 0}%` }} />
              </div>
              <p className="text-[9px] text-slate-400 mt-1">{progress.current}/{progress.target}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}